<ng-container [ngSwitch]="!!activityCategory ? activityCategory.id : 0">

	<!-- University / Public Service  -->
	<ng-container *ngSwitchCase="1"> 
		<div class="row text-muted sorter-row" role="row">
			<div [ngClass]="columnClass('name')">
				<sort-column-header 
					[column]="sortColumns.name"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Name'"></sort-column-header>
			</div>
			<div [ngClass]="columnClass('subType')">
				<sort-column-header 
          role="columnheader"
					[column]="sortColumns.subTypeId"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Sub Type'"></sort-column-header>
			</div>
			<div [ngClass]="columnClass('areaOfService')">
				<sort-column-header
          role="columnheader" 
					[column]="sortColumns.areaOfService"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Area of Service'"></sort-column-header>
			</div>
			<div [ngClass]="columnClass('role')">
				<sort-column-header 
          role="columnheader"
					[column]="sortColumns.role"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Role'"></sort-column-header>
			</div>
			<div class="text-right text-nowrap" [ngClass]="columnClass('date')">
				<sort-column-header 
          role="columnheader"
					[column]="sortColumns.date"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Date'"></sort-column-header>
			</div>
		</div>

		<div *ngIf="activities.length == 0"
			class="text-center text-muted"
			style="padding:1rem; font-size:1rem;">
				<i class="fa fa-fw fa-search"></i>
				No Activites Found
		</div>

		<div class="scroll-viewport" [class.fadeToGray]="fadeToGray" role="rowgroup">
			<div class="fade-out-top"></div>
			<div class="scroll-container scrollbar-thin" 
			[ngStyle]="{
				maxHeight:maxHeight,
				paddingRight: paddingRight,
				paddingLeft: paddingLeft
			}">

				<a *ngFor="let activity of activities"
				class="card activity-card" (click)="activityClick.emit(activity)"
				[class.highlighted]="highlightedActivity == activity"
				tabindex="0"
        role="row">
					<div class="card-body align-items-center" role="presentation">
						<div class="row align-items-center">

							<div [ngClass]="columnClass('name')" role="gridcell">
								<div class="media align-items-center">
									<div class="float-left">
										<activity-type-icon
											[activityTypeId]="types.getTypeIdBySubTypeId(activity.subTypeId)"
											class="mr-3 text-muted"
											[attr.aria-label]="'Activity type icon'"></activity-type-icon>
									</div>
									<div class="media-body" aria-label="{{activity.name}}">
										<span>{{activity.name}}</span>
										<activity-collaboration-flag [activity]="activity" [attr.aria-label]="'Collaboration indicator'"></activity-collaboration-flag>
									</div>
								</div>
							</div>

							<div [ngClass]="columnClass('subType')" role="gridcell" aria-label="{{getActivitySubTypeName(activity)}}">
								<activity-invalid-reason-icon [messages]="activity.invalidReasons" [attr.aria-label]="'Invalid reason indicator'"></activity-invalid-reason-icon>
								<span >{{getActivitySubTypeName(activity)}}</span>
							</div>

							<div [ngClass]="columnClass('areaOfService')" role="gridcell" aria-label="{{getActivityAreaOfServiceName(activity)}}">
									{{getActivityAreaOfServiceName(activity)}}
							</div>

							<div [ngClass]="columnClass('role')" role="gridcell" aria-label="{{getActivityRoleName(activity)}}">
								{{getActivityRoleName(activity)}}
							</div>

							<div class="text-right text-nowrap" [ngClass]="columnClass('date')" role="gridcell" aria-label="{{activity.date}}">
								<activity-date [activityDate]="activity.date"></activity-date>
							</div>

						</div>
					</div>
				</a> 
			</div>
			<div class="fade-out-bottom"></div>
		</div>
	</ng-container>

	<!-- Professional Competence and Evidence of Professional Competence and Training  -->
	<ng-container *ngSwitchCase="2"> 
		<div class="row text-muted sorter-row" role="row">
			<div [ngClass]="columnClass('name')">
				<sort-column-header
          role="columnheader" 
					[column]="sortColumns.name"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Name'"></sort-column-header>
			</div>
			<div [ngClass]="columnClass('subType')">
				<sort-column-header 
          role="columnheader"
					[column]="sortColumns.subTypeId"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Sub Type'"></sort-column-header>
			</div>
			<div [ngClass]="columnClass('location')">
				<sort-column-header 
          role="columnheader"
					[column]="sortColumns.location"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Location'"></sort-column-header>
			</div>
			<div class="text-right text-nowrap" [ngClass]="columnClass('date')">
				<sort-column-header 
          role="columnheader"
					[column]="sortColumns.date"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Date'"></sort-column-header>
			</div>
		</div>

		<div *ngIf="activities.length == 0"
			class="text-center text-muted"
			style="padding:1rem; font-size:1rem;">
				<i class="fa fa-fw fa-search"></i>
				No Activites Found
		</div>

		<div class="scroll-viewport" [class.fadeToGray]="fadeToGray" role="rowgroup">
			<div class="fade-out-top"></div>
			<div class="scroll-container scrollbar-thin" 
			[ngStyle]="{
				maxHeight:maxHeight,
				paddingRight: paddingRight,
				paddingLeft: paddingLeft
			}">
				<a *ngFor="let activity of activities"
				class="card activity-card" (click)="activityClick.emit(activity)"
				[class.highlighted]="highlightedActivity == activity"
				tabindex="0" 
        role="row">
					<div class="card-body align-items-center" role="presentation">
						<div class="row align-items-center">

							<div [ngClass]="columnClass('name')" role="gridcell">
								<div class="media align-items-center">
									<div class="float-left">
										<activity-type-icon
											[activityTypeId]="types.getTypeIdBySubTypeId(activity.subTypeId)"
											class="mr-3 text-muted"
											[attr.aria-label]="'Activity type icon'"></activity-type-icon>
									</div>
									<div class="media-body" aria-label="{{activity.name}}">
										<span>{{activity.name}}</span>
										<activity-collaboration-flag [activity]="activity" [attr.aria-label]="'Collaboration indicator'"></activity-collaboration-flag>
									</div>
								</div>
							</div>

							<div [ngClass]="columnClass('subType')" role="gridcell" aria-label="{{getActivitySubTypeName(activity)}}">
								<activity-invalid-reason-icon [messages]="activity.invalidReasons" [attr.aria-label]="'Invalid reason indicator'"></activity-invalid-reason-icon>
								<span>{{getActivitySubTypeName(activity)}}</span>
							</div>

							<div [ngClass]="columnClass('location')" role="gridcell" aria-label="{{getLocationName(activity)}}">
								{{getLocationName(activity)}}
							</div>

							<div class="text-right text-nowrap" [ngClass]="columnClass('date')" role="gridcell" aria-label="{{activity.date}}">
								<activity-date [activityDate]="activity.date"></activity-date>
							</div>

						</div>
					</div>
				</a> 
			</div>
			<div class="fade-out-bottom"></div>
		</div>
	</ng-container>

	<ng-container *ngSwitchDefault>
		<div class="row text-muted sorter-row" role="row">
			<div style="padding-left: 10em;" [ngClass]="columnClass('name')">
				<sort-column-header
          role="columnheader" 
					[column]="sortColumns.name"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Name'"></sort-column-header>
			</div>
			<div [ngClass]="columnClass('type')">
				<sort-column-header 
          role="columnheader"
					[column]="sortColumns.typeId"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Type'"></sort-column-header>
			</div>

			<div *ngIf="!hideParent" [ngClass]="columnClass('parent')">
				<sort-column-header 
          role="columnheader"
					[column]="sortColumns.parent"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Parent'"></sort-column-header>
			</div>

			<div *ngIf="!hideTags"   [ngClass]="columnClass('tags')">
				<sort-column-header 
          role="columnheader"
					[column]="sortColumns.tags"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Tags'"></sort-column-header>
			</div>

			<div class="text-right text-nowrap" [ngClass]="columnClass('date')">
				<sort-column-header 
          role="columnheader"
					[column]="sortColumns.date"
					[(currentSorting)]="currentSorting"
					[attr.aria-label]="'Sort by Date'"></sort-column-header>
			</div>
		</div>

		<div *ngIf="activities.length == 0"
			class="text-center text-muted"
			style="padding:1rem; font-size:1rem;">
				<i class="fa fa-fw fa-search"></i>
				No Activites Found
		</div>

		<div class="scroll-viewport" [class.fadeToGray]="fadeToGray" role="rowgroup">
			<div class="fade-out-top"></div>
			<div class="scroll-container scrollbar-thin" 
			[ngStyle]="{
				maxHeight:maxHeight,
				paddingRight: paddingRight,
				paddingLeft: paddingLeft
			}">  
			<div class="d-flex justify-content-end mb-3">
				<button [disabled]="SelectedActivityCount===0" class="btn btn-outline-primary btn-sm" (click)="openBulkUpdateModal()" [attr.aria-label]="'Update ' + SelectedActivityCount + ' selected activities'" >
					Update Selected Activites ({{SelectedActivityCount}})
				</button>
			</div>
				<div *ngFor="let activity of activities; let i=index;" style="cursor: pointer;"
				class="card activity-card" [class.highlighted]="highlightedActivity == activity"
				tabindex="0"
        role="row">
					<div class="card-body align-items-center" role="presentation">
						<div class="row align-items-center" >
							<div [ngClass]="columnClass('name')">
								<div class="media align-items-center">
									<div class="align-items-center" *ngIf="!!activity.parent.value" style="padding-right: 1em;">
										<input type="checkbox" aria-label="Select Activity" [(ngModel)]="activities[i].checked" (click)="selectedActivity(i)" > 
									</div> 
									<div class="float-left">
										<activity-type-icon
											[activityTypeId]="types.getTypeIdBySubTypeId(activity.subTypeId)"
											class="mr-3 text-muted"
											[attr.aria-label]="'Activity type icon'"></activity-type-icon>
									</div>
									<div class="media-body" (click)="activityClick.emit(activity)" aria-label="{{activity.name}}">
										<span>{{activity.name}}</span>
										<activity-collaboration-flag [activity]="activity" [attr.aria-label]="'Collaboration indicator'"></activity-collaboration-flag>
								    </div>
								</div>
							</div>

							<div [ngClass]="columnClass('type')" (click)="activityClick.emit(activity)" aria-label="{{getActivityTypeName(activity)}}">
								<activity-invalid-reason-icon [messages]="activity.invalidReasons" [attr.aria-label]="'Invalid reason indicator'"></activity-invalid-reason-icon>
							    <span>{{getActivityTypeName(activity)}}</span>
							</div>

							<div [ngClass]="columnClass('parent')" *ngIf="!hideParent" (click)="activityClick.emit(activity)">
								<div [ngSwitch]="!!activity.parent.value">
									<div *ngSwitchCase="true">
										<div [ngSwitch]="activity.parent.value.type">
											<div *ngSwitchCase="ActivityParentType.Theme" aria-label="{{activity.parent.value.name}} (Theme)">
												<span>{{activity.parent.value.name}}</span>
												<span class="text-muted text-sm">(Theme)</span>
											</div>
											<div *ngSwitchCase="ActivityParentType.Project" aria-label="{{activity.parent.value.name}} (Project)">
												<span>{{activity.parent.value.name}}</span>
												<span class="text-muted text-sm">(Project)</span>
											</div>
										</div>
									</div>
									<div *ngSwitchDefault class="text-muted">None</div>
								</div>
							</div>

							<div [ngClass]="columnClass('tags')" *ngIf="!hideTags" (click)="activityClick.emit(activity)" role="gridcell" aria-label="{{activity.tags.count}} tags">
								<tag-list [tags]="activity.tags" [keyword]="keywordToHighlight" [attr.aria-label]="'Tags: ' + activity.tags.count + ' tags'"></tag-list>
							</div>

							<div class="text-right text-nowrap" [ngClass]="columnClass('date')" (click)="activityClick.emit(activity)" aria-label="{{activity.date}}" role="gridcell">
								<activity-date [activityDate]="activity.date"></activity-date>
							</div>

						</div>
					</div>
				</div> 
			</div>
			<div class="fade-out-bottom"></div>
		</div>
	</ng-container>
</ng-container>